import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "hidden lg:block"
};
const _hoisted_2 = {
  class: "subscription"
};
const _hoisted_3 = {
  class: "lg:hidden"
};
const _hoisted_4 = {
  class: "subscription-mobile"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.item.base.isFullScreen ? '' : 'noFullScreen')
  }, [_createElementVNode("span", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["subscription-flex", _ctx.item.data.positionRadio === '1' ? 'left' : _ctx.item.data.positionRadio === '2' ? 'bottom' : 'right'])
  }, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.subscribesContent = $event)
  }, null, 512), [[_vModelText, _ctx.subscribesContent]]), _createElementVNode("button", {
    class: "subsscribesBtn",
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.subscribesBtn && _ctx.subscribesBtn(...args)),
    style: _normalizeStyle({
      color: _ctx.item.data.fontColor,
      backgroundColor: _ctx.item.data.bgColor
    })
  }, _toDisplayString(_ctx.item.data.val), 5)], 2)])]), _createElementVNode("span", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["subscription-flex", _ctx.item.data.positionRadio === '1' ? 'left' : _ctx.item.data.positionRadio === '2' ? 'bottom' : 'right'])
  }, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.subscribesContent = $event)
  }, null, 512), [[_vModelText, _ctx.subscribesContent]]), _createElementVNode("button", {
    class: "subsscribesBtn",
    onClick: _cache[3] || (_cache[3] = (...args) => _ctx.subscribesBtn && _ctx.subscribesBtn(...args)),
    style: _normalizeStyle({
      color: _ctx.item.data.fontColor,
      backgroundColor: _ctx.item.data.bgColor
    })
  }, _toDisplayString(_ctx.item.data.val), 5)], 2)])])], 2);
}